import Utilities from '@util/Utilities';
import { BellAlertIcon } from '@heroicons/react/16/solid';
import React from 'react';
import CalendarDay from '@app/state/calendar/CalendarDay';
import MarketStateForDayNotificationsOutput from '@app/model/market_state/MarketStateForDayNotificationsOutput';
import { MarketStateStatDateCompetitorSnapshot } from '@app/model/market_state/MarketStateStatDateCompetitorSnapshot';

const AlertIndicator: React.FunctionComponent<{
	marketStatDateCompetitorSnapshot: MarketStateStatDateCompetitorSnapshot | undefined,
	marketStateNotificationsForDay: MarketStateForDayNotificationsOutput | undefined,
	calendarDay: CalendarDay,
	type?: 'BELL' | 'DOT'
}> = ({ marketStatDateCompetitorSnapshot, marketStateNotificationsForDay, calendarDay, type = 'BELL' }) => {
	if (type === 'BELL')
		return <BellAlertIcon
			className={Utilities.classNames('h-3.5 w-3.5', (!!marketStatDateCompetitorSnapshot && !calendarDay.isPast && !!marketStateNotificationsForDay && marketStateNotificationsForDay.hasNotifications) ? 'text-amber-400' : 'text-slate-200')} />;
	else if (type === 'DOT' && !!marketStatDateCompetitorSnapshot && !calendarDay.isPast && !!marketStateNotificationsForDay && marketStateNotificationsForDay.hasNotifications)
		return <span
			className="rounded-full h-2 w-2 mr-1.5 bg-amber-500" />;
	else
		return null;
};

export default AlertIndicator;